import { LegacyGatewayBase } from './base'
import { IAdmissionProps } from '@/entities/Legacy/Admission'
import { CheckIn, CheckOut } from '@/infrastructure/network/Legacy/requests/admission'

export default class Admission extends LegacyGatewayBase {
  async CheckIn(params: IAdmissionProps) {
    await this.apiClient.request(new CheckIn(params))
  }

  async CheckOut(params: IAdmissionProps) {
    await this.apiClient.request(new CheckOut(params))
  }
}
